import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { AdminNewsListNewsForPlannerFragmentDoc } from '../../features/adminNews/components/AdminNewsList/AdminNewsList.generated';
export type DashboardPageNewsSectionNewsForPlannerFragment = { __typename?: 'Query', newsForPlanner: { __typename?: 'NewsForPlannerConnection', edges: Array<{ __typename?: 'NewsForPlannerEdge', node: { __typename?: 'NewsForPlanner', id: string, title: string, body: string, publishedAt: TimeString } }> } };

export const DashboardPageNewsSectionNewsForPlannerFragmentDoc = gql`
    fragment DashboardPageNewsSectionNewsForPlanner on Query {
  newsForPlanner(first: 1) {
    edges {
      node {
        ...AdminNewsListNewsForPlanner
      }
    }
  }
}
    ${AdminNewsListNewsForPlannerFragmentDoc}`;